import React from "react";
import { StatCard, StatCardLabel, StatCardsRow, StatCardValue } from "./stat-cards.styles";

interface StatItem {
  label: string;
  value: string;
  variant?: 'blue' | 'green';
}

interface StatCardsProps {
  items: StatItem[];
}

export function StatCards({ items }: StatCardsProps) {
  return (
    <StatCardsRow>
      {items.map((item) => (
        <StatCard key={item.label} $variant={item.variant}>
          <StatCardLabel>{item.label}</StatCardLabel>
          <StatCardValue $variant={item.variant}>{item.value}</StatCardValue>
        </StatCard>
      ))}
    </StatCardsRow>
  );
}
